import * as Config from '../config';
import { useState, useCallback, useContext, useEffect } from "react";
import { ReactReduxContext } from 'react-redux';

import {
  setRequestError
} from "../actions/index";

let basePath = null;
const useGetFromApi = (id, path, perPage = 100, customReduceFormat = null) => {
  const { store } = useContext(ReactReduxContext);
  const { dispatch } = store;
  const state = store.getState();
  const [response, setResponse] = useState(null);

  //Fix API request - Invalid per_page
  perPage = (perPage === 0) ? 1 : perPage;

  const onLoadMore = useCallback((nextPath, isSplice) => (callback) => loadMore(nextPath, isSplice, callback), []); // eslint-disable-line react-hooks/exhaustive-deps

  const loadMore = useCallback((nextPath, isSplice = false, callback) => {
    if (state.api && nextPath) {
      const url = nextPath.includes(`http`) ? nextPath : `https://${nextPath}`;
      state.api.getFromURL(url).then( res => {

        //EXCLUDE - TEMPORARY
        const [realPath, exclude] = basePath.split('|');
        const listExclude = (exclude) ? exclude.split(`,`).map( x => parseInt(x) ) : [];
        const filterExclude = (realPath.includes(`charts`)) ? (x => (x.artist && !listExclude.includes(x.artist.id) )) : (x => true);
        const results = Config.HAS_FILTER_EXCLUDE ? res.data.results.filter(filterExclude) :  res.data.results;

        setResponse(stack => {
          return {
            ...stack,
            itemsFull: [...stack.itemsFull, ...results],
            items: isSplice ? [...stack.items] : [...stack.itemsFull, ...results],
            next: res.data.next,
            count: res.data.count,
            onLoadMore: onLoadMore(res.data.next, false),
            // pagination: { ...stack.pagination, total: stack.itemsFull.length + results.length },
            loading: false
          }
        })
        if (callback) callback();
      }).catch( e => console.log(`error`, e) );
    }
  }, [state.api, onLoadMore]);

  const setApiFilters = useCallback((pathFilters) => {
    if (state.api) {
      setResponse(stack => ({ ...stack, items: null }))
      // IMPORTANT DON'T TAKE THE HARDCODE FILTERS ARTISTS WITH |
      state.api.getFromApi(basePath + pathFilters, false).then( res => {
        setResponse(stack => ({
          ...stack,
          itemsFull:  res.data.results,
          items: res.data.results,
          next: res.data.next,
          onLoadMore: onLoadMore(res.data.next, false),
          pagination: { ...stack.pagination, start: 0, end: perPage, total: res.data.results.length }
        }))
      }).catch( e => console.log(`error`, e) );
    }
  }, [state.api, onLoadMore, perPage]);

  const nextStack = useCallback((nextPath) => {
    setResponse( stack => {
      const start = stack.pagination.start + perPage;
      const end = stack.pagination.end + perPage;
      const n = start / (2 * perPage);
      let loading = (((n - Math.floor(n)) !== 0) && stack.next); //((start + (2 * perPage)) >= stack.itemsFull.length && stack.next);
      if (loading) {
        loadMore(stack.next, true);
      }
      return {
        ...stack,
        items: [...stack.itemsFull].splice(start, perPage),
        pagination: { ...stack.pagination, start, end },
        loading
      };
    })
  }, [loadMore, perPage]);

  const prevStack = useCallback(() => {
    setResponse( stack => {
      const start = (stack.pagination.start - perPage <= 0) ? 0 : stack.pagination.start - perPage;
      const end = (stack.pagination.end - perPage <= perPage) ? perPage : stack.pagination.end - perPage;
      return { ...stack,
        items: [...stack.itemsFull].splice(start, perPage),
        pagination: { ...stack.pagination, start, end }
      };
    } )
  }, [perPage]);

  // TODO - Cleanup axios
  useEffect(() => {
    if (state.api && path) {
      //EXCLUDE - TEMPORARY
      let [realPath, exclude] = path.split('|');
      const listExclude = (exclude) ? exclude.split(`,`).map( x => parseInt(x) ) : [];
      const filterExclude = (realPath.includes(`charts`)) ? (x => (x.artist && !listExclude.includes(x.artist.id) )) : (x => true);

      // Request exactly the number of elements (Opti)
      if (realPath.includes(`?`) && !realPath.includes(`per_page`)) { realPath += `&per_page=${perPage * 2}` }

      const isCache = (!realPath.includes('/my/playlists'));
      state.api.getFromApi(realPath, isCache).then( res => {
        basePath = realPath;
        let results = Config.HAS_FILTER_EXCLUDE ? res.data.results.filter(filterExclude) : res.data.results;

        if (customReduceFormat) {
          results = results.reduce(customReduceFormat, []);    
        }

        setResponse({
          id,
          itemsFull: results,
          items: [...results].splice(0, perPage),
          next: res.data.next,
          count: res.data.count,
          pagination: { start: 0, end: perPage, total: /*results.length*/ res.data.count , nextStack, prevStack },
          loading: false,
          onLoadMore: onLoadMore(res.data.next, false),
          setApiFilters
        });

      }).catch( e => {
        const sError = JSON.parse(JSON.stringify(e, null, 2));
        if (sError && sError.message && sError.message.includes(`401`)) { // Session Expired
          dispatch(setRequestError(sError));
        }
        setResponse({ id, itemsFull: [], items: [], next: null, pagination: {}, loading: false, onLoadMore: null })
      } );

    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, path, state.api, perPage, nextStack, prevStack, onLoadMore, setApiFilters, dispatch]) // warning state.cache

  return [response];
};

export default useGetFromApi;
